import React, { useRef, useEffect, useState } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import DeleteDevicePic from "../../../../assets/images/deletedSuccessfully.png";

const BlockUnblock = ({ showModal, closeModal, handleSubmit }) => {
  const modalRef = useRef();

  useEffect(() => {
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);

  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h6 className="modal-title text-blue-900">Block Contact</h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <img
              className="d-block mx-auto mt-6"
              src={DeleteDevicePic}
              alt=""
            />
            <h6 className="mt-6 mb-9 text-center text-blue-900">
              Do you really want to block contact?
            </h6>
            <div className="grid gap-3">
              <button
                className="btn btn-primary g-col-12"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleSubmit}
              >
                <span className="btn-upper-case">yes</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockUnblock;
